import { AMENITY_ICON_PATHS, AmenityIconId } from '../iconResolver'

interface AmenityIconProps {
  iconId: AmenityIconId
  className?: string
}

/**
 * Renders one of the static Lucide-subset icons ported from the toolkit's
 * `amenity-icons` module (see iconResolver.ts). `AMENITY_ICON_PATHS` is a
 * fixed, code-owned constant — never user input — reaching this sink, the
 * same justification the codebase already uses for CSS injection
 * (`components/Stylesheet.tsx`).
 */
export default function AmenityIcon({ iconId, className = 'amenity-icon-svg aminity-icon-svg' }: AmenityIconProps) {
  const markup = AMENITY_ICON_PATHS[iconId]
  if (!markup) return null
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      dangerouslySetInnerHTML={{ __html: markup }}
    />
  )
}
